import React, { PureComponent } from 'react';
import { withRouter } from '@client/shared/utils/routerUtils/routerUtils';
import styles from './myDonationsRoute.scss';

class MyDonationsRoute extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={styles.myDonationsRoute}></div>;
  }
}

export default withRouter(MyDonationsRoute);
